module.exports = __webpack_public_path__ + "static/img/turntable.ccff7ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/turntable.png
// module id = Y+a5
// module chunks = 87